import React from 'react'

const Returned = ({ fill, height = 35, viewBox = '0 0 42 42', width = 35 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
    <path id="Caminho_3613" data-name="Caminho 3613" d="M49.5,78.232a16.971,16.971,0,0,0,1.974.116A17.656,17.656,0,0,0,63.91,48.209h0a17.533,17.533,0,0,0-12.472-5.183h-.022A17.646,17.646,0,0,0,38.539,72.736l.789.841H34.6v2.292h7.849l1.741-7.837-2.245-.5-.986,4.416-.646-.682a15.326,15.326,0,1,1,9.448,4.688Z" transform="translate(-33.74 -43.025)" fill={fill}/>
  </svg>
)

export default Returned
